import axios from "@/components/api/axios";

const get = () => {
    return axios.get(
        '/account',
        {})
}

export default {
    get,
}